import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { rowsPerPageJsonData } from "../utils/JsonData";
import { t } from "i18next";


const initialState = {
  nightApprovalDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  nightApprovalSearchFilters: {
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  zOutReportData: {},
  zOutAuditStatus: 0,
  zOutDate: localStorage.getItem("NightReportDate"),
  nightAuditNoShowDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  nightAuditNoShowrow: [],
  nightAuditNoshowDate: localStorage.getItem("NightReportDate"),
  tax_taxExempt: {},
  tax_tax_exempt_revenue_summary_by_tax: {
    tax: {
      title: "",
      col1: "",
      col2: "",
    },
    current_tax_confi: {
      title: "",
      col1: "",
      col2: "",
    },
  },
  tax_exempt_revenue: {
    exempt_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    exempt_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    exempt_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_exempt: {
    exempt_through: {
      title: "",
      col1: "",
      col2: "",
    },
    exempt_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    exempt_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_tax_exempt_revenue_summary_by_transaction_code: {
    tax_exempt_trans_code: {
      title: " ",
      col1: "",
      col2: "",
    },
    tc_exempt_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    tc_exempt_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    tc_exempt_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_tax_refund_revenue_summary_by_transaction_code: {
    tax_refund_trans_code: {
      title: " ",
      col1: "",
      col2: "",
    },
    tc_refund_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    tc_refund_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    tc_refund_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_date: localStorage.getItem("NightReportDate"),
  hotelJournalSummaryList: [
    {
      description: "",
      postings1: 0,
      corrections: 0,
      adjustments: 0,
      totals: 0,
      transactions: 0,
      post: 0,
      corr: 0,
      adj: 0,
    },
  ],
  hotelJournalSummaryDetailedTransList: [
    {
      dateTime: moment(moment().subtract(7, "days")).format(
        "MM/DD/YYYY hh:mm A"
      ),
      transactionId: "",
      description: "",
      accountType: "",
      amount: "$ 0",
      paymentMethod: "",
      department: "",
    },
  ],
  hotelJournalSummaryTotal: {
    totalOpeningBalance: 0,
    todaysTotal: 0,
    todaysAdjustments: 0,
    balanceForward: 0,
  },
  hotelJournalSummaryDate: localStorage.getItem("NightReportDate"),

  finalTransaction_account_ReceivableList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_administrationList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_banquet_BeverageList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_cashList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_credit_CardsList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_miscellaneousList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_room_revenueList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_taxList: [
    {
      description: "",
      todays_opening_balance: 0,
      todays_total: 0,
      todays_adjustments: 0,
      todays_nel: 0,
      ptd_totals: 0,
      ytd_totals: 0,
    },
  ],
  finalTransaction_finalTransactionCloseoutDate:
    localStorage.getItem("NightReportDate"),
  hotelStatasticsDate: localStorage.getItem("NightReportDate"),
  hotalStatisticsList: [],
  inHouseDate: localStorage.getItem("NightReportDate"),
  inHouseList: [],
  inhouseDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inhouseDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  checkinList: [],
  checkinDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  checkinDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  checkinSearchFilters: {
    searchText: "",
    startDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
    endDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
    booking_source: 0,
  },

  checkOutList: [],
  checkOutDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  checkOutDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  checkOutSearchFilters: {
    searchText: "",
    startDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
    endDate:  moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
  },

  ledgerSummaryDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  ledgerSummarySearchFilters: {
    searchText: "",
    startDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
  },

  activityLogDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  activityLogDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  activityLogSearchFilters: {
    searchText: "",
    startDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
  },

  revenueByRoomTypeList: [],
  revenueBreakdownList: [],
  revenueAdrList: [],
  flashDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  adrDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  flashSearchFilters: {
    startDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
    endDate: moment(localStorage.getItem("NightReportDate")).format("YYYY-MM-DD"),
  },
  flashSummuryData: [],
  flashRoomSoldArr:[],
  flashRevenueSummuryData: [],
  flashAdrSummuryData: [],
  flashDataGridColumns: [
    { field: "name", headerName: t("Date"), flex: 1 },
    { field: "noOfRooms", headerName: t("No. of Rooms"), flex: 1 },
    { field: "revenue", headerName: t("Revenue"), flex: 1 },
  ],
  flashRevenueDataGridColumns: [
    { field: "name", headerName: t("Date"), flex: 1 },
  ],
  flashTab: 0,
};

const nightReportSlice = createSlice({
  name: "nightReport",
  initialState: initialState,
  reducers: {
    nightApprovalDatagridOptionsSuccess: (state, action) => {
      state.nightApprovalDatagridOptions = {
        ...state.nightApprovalDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    nightApprovalSearchFiltersSuccess: (state, action) => {
      state.nightApprovalSearchFilters = {
        ...state.nightApprovalSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    zOutReportDataSuccess: (state, action) => {
      state.zOutReportData = action.payload;
    },
    zOutAuditStatusSuccess: (state, action) => {
      state.zOutAuditStatus = action.payload;
    },
    zOutDateSuccess: (state, action) => {
      state.zOutDate = action.payload;
    },
    nightAuditNoShowrowSuccess: (state, action) => {
      state.nightAuditNoShowrow = action.payload;
    },
    nightAuditNoShowDatagridOptionsSuccess: (state, action) => {
      state.nightAuditNoShowDatagridOptions = {
        ...state.nightAuditNoShowDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    nightAuditNoshowDateSuccess: (state, action) => {
      state.nightAuditNoshowDate = action.payload;
    },
    tax_taxExemptSuccess: (state, action) => {
      state.tax_taxExempt = action.payload;
    },
    tax_tax_exempt_revenue_summary_by_taxSuccess: (state, action) => {
      state.tax_tax_exempt_revenue_summary_by_tax = action.payload;
    },
    tax_exempt_revenueSuccess: (state, action) => {
      state.tax_exempt_revenue = action.payload;
    },
    tax_exemptSuccess: (state, action) => {
      state.tax_exempt = action.payload;
    },
    tax_tax_exempt_revenue_summary_by_transaction_codeSuccess: (
      state,
      action
    ) => {
      state.tax_tax_exempt_revenue_summary_by_transaction_code = action.payload;
    },
    tax_tax_refund_revenue_summary_by_transaction_codeSuccess: (
      state,
      action
    ) => {
      state.tax_tax_refund_revenue_summary_by_transaction_code = action.payload;
    },
    tax_dateSuccess: (state, action) => {
      state.tax_date = action.payload;
    },

    hotelJournalSummaryListSuccess: (state, action) => {
      state.hotelJournalSummaryList = action.payload;
    },
    hotelJournalSummaryDetailedTransListSuccess: (state, action) => {
      state.hotelJournalSummaryDetailedTransList = action.payload;
    },
    hotelJournalSummaryTotalSuccess: (state, action) => {
      state.hotelJournalSummaryTotal = action.payload;
    },
    hotelJournalSummaryDateSuccess: (state, action) => {
      state.hotelJournalSummaryDate = action.payload;
    },

    finalTransaction_account_ReceivableList_success: (state, action) => {
      state.finalTransaction_account_ReceivableList = action.payload;
    },
    finalTransaction_administrationList_success: (state, action) => {
      state.finalTransaction_administrationList = action.payload;
    },
    finalTransaction_banquet_BeverageList_success: (state, action) => {
      state.finalTransaction_banquet_BeverageList = action.payload;
    },
    finalTransaction_cashList_success: (state, action) => {
      state.finalTransaction_cashList = action.payload;
    },
    finalTransaction_credit_CardsList_success: (state, action) => {
      state.finalTransaction_credit_CardsList = action.payload;
    },
    finalTransaction_miscellaneousList_success: (state, action) => {
      state.finalTransaction_miscellaneousList = action.payload;
    },
    finalTransaction_room_revenueList_success: (state, action) => {
      state.finalTransaction_room_revenueList = action.payload;
    },
    finalTransaction_taxList_success: (state, action) => {
      state.finalTransaction_taxList = action.payload;
    },
    finalTransaction__finalTransactionCloseoutDate_success: (state, action) => {
      state.finalTransaction_finalTransactionCloseoutDate = action.payload;
    },
    hotelStatasticsDatesuccess: (state, action) => {
      state.hotelStatasticsDate = action.payload;
    },
    hotalStatisticsListsuccess: (state, action) => {
      state.hotalStatisticsList = action.payload;
    },

    inHouseDatesuccess: (state, action) => {
      state.inHouseDate = action.payload;
    },
    inHouseListSuccess: (state, action) => {
      state.inHouseList = action.payload;
    },
    inHouseListFailed: (state, action) => {
      state.inHouseList = [];
    },
    inhouseDatagridOptionsSucces: (state, action) => {
      state.inhouseDatagridOptions = {...state.inhouseDatagridOptions, [action.payload.key]: action.payload.value}
    },
    inhouseDatagridPrintOptionsSucces: (state, action) => {
      state.inhouseDatagridPrintOptions = {...state.inhouseDatagridPrintOptions, [action.payload.key]: action.payload.value}
    },
    checkinDatesuccess: (state, action) => {
      state.checkinDate = action.payload;
    },
    checkinListSuccess: (state, action) => {
      state.checkinList = action.payload;
    },
    checkinListFailed: (state, action) => {
      state.checkinList = [];
    },
    checkinDatagridOptionsSucces: (state, action) => {
      state.checkinDatagridOptions = {...state.checkinDatagridOptions, [action.payload.key]: action.payload.value}
    },
    checkinDatagridPrintOptionsSucces: (state, action) => {
      state.checkinDatagridPrintOptions = {...state.checkinDatagridPrintOptions, [action.payload.key]: action.payload.value}
    },
    checkinSearchFilterSucces: (state, action) => {
      state.checkinSearchFilters = {...state.checkinSearchFilters, [action.payload.key]: action.payload.value}
    },

    checkOutListSuccess: (state, action) => {
      state.checkOutList = action.payload;
    },
    checkOutListFailed: (state, action) => {
      state.checkOutList = [];
    },
    checkOutDatagridOptionsSuccess: (state, action) => {
      state.checkOutDatagridOptions = {...state.checkOutDatagridOptions, [action.payload.key]: action.payload.value}
    },
    checkOutDatagridPrintOptionsSuccess: (state, action) => {
      state.checkOutDatagridPrintOptions = {...state.checkOutDatagridPrintOptions, [action.payload.key]: action.payload.value}
    },
    checkOutSearchFilterSuccess: (state, action) => {
      state.checkOutSearchFilters = {...state.checkOutSearchFilters, [action.payload.key]: action.payload.value}
    },
    ledgerSummaryDatagridOptionsSuccess: (state, action) => {
      state.ledgerSummaryDatagridOptions = {...state.ledgerSummaryDatagridOptions, [action.payload.key]: action.payload.value}
    },
    ledgerSummarySearchFiltersSuccess: (state, action) => {
      state.ledgerSummarySearchFilters = {...state.ledgerSummarySearchFilters, [action.payload.key]: action.payload.value}
    },
    activityLogDatagridOptionsSucces: (state, action) => {
      state.activityLogDatagridOptions = {...state.activityLogDatagridOptions, [action.payload.key]: action.payload.value}
    },
    activityLogDatagridPrintOptionsSucces: (state, action) => {
      state.activityLogDatagridPrintOptions = {...state.activityLogDatagridPrintOptions, [action.payload.key]: action.payload.value}
    },
    activityLogSearchFiltersSucces: (state, action) => {
      state.activityLogSearchFilters = {...state.activityLogSearchFilters, [action.payload.key]: action.payload.value}
    },
    
    
    revenueByRoomTypeListSuccess: (state, action) => {
      state.revenueByRoomTypeList = action.payload;
    },
    revenueByRoomTypeListFailed: (state, action) => {
      state.revenueByRoomTypeList = [];
    },
    revenueBreakdownListSuccess: (state, action) => {
      state.revenueBreakdownList = action.payload;
    },
    revenueBreakdownListFailed: (state, action) => {
      state.revenueBreakdownList = [];
    },
    revenueAdrListSuccess: (state, action) => {
      state.revenueAdrList = action.payload;
    },
    revenueAdrListFailed: (state, action) => {
      state.revenueAdrList = [];
    },
    flashDatagridOptionsSuccess: (state, action) => {
      state.flashDatagridOptions = {...state.flashDatagridOptions, [action.payload.key]: action.payload.value}
    },
    revenueDatagridOptionsSuccess: (state, action) => {
      state.revenueDatagridOptions = {...state.revenueDatagridOptions, [action.payload.key]: action.payload.value}
    },
    adrDatagridOptionsSuccess: (state, action) => {
      state.adrDatagridOptions = {...state.adrDatagridOptions, [action.payload.key]: action.payload.value}
    },
    flashSearchFilterSuccess: (state, action) => {
      state.flashSearchFilters = {...state.flashSearchFilters, [action.payload.key]: action.payload.value}
    },
    flashTabSuccess: (state, action) => {
      state.flashTab = action.payload;
    },
    flashSummuryDataSuccess: (state, action) => {
      state.flashSummuryData = action.payload;
    },
    flashRoomSoldArrSuccess: (state, action) => {
      state.flashRoomSoldArr = action.payload;
    },
     flashRevenueSummuryDataSuccess: (state, action) => {
      state.flashRevenueSummuryData = action.payload;
    },
    flashAdrSummuryDataSuccess: (state, action) => {
      state.flashAdrSummuryData = action.payload;
    },
    flashDataGridColumnsSuccess: (state, action) => {
      state.flashDataGridColumns = action.payload;
    },
    flashRevenueDataGridColumnsSuccess: (state, action) => {
      state.flashRevenueDataGridColumns = action.payload;
    },
  },
});

export const {
  nightApprovalDatagridOptionsSuccess,
  nightApprovalSearchFiltersSuccess,
  zOutReportDataSuccess,
  zOutAuditStatusSuccess,
  zOutDateSuccess,
  nightAuditNoShowrowSuccess,
  nightAuditNoShowDatagridOptionsSuccess,
  nightAuditNoshowDateSuccess,
  tax_taxExemptSuccess,
  tax_tax_exempt_revenue_summary_by_taxSuccess,
  tax_exempt_revenueSuccess,
  tax_exemptSuccess,
  tax_tax_exempt_revenue_summary_by_transaction_codeSuccess,
  tax_tax_refund_revenue_summary_by_transaction_codeSuccess,
  tax_dateSuccess,
  hotelJournalSummaryListSuccess,
  hotelJournalSummaryDetailedTransListSuccess,
  hotelJournalSummaryTotalSuccess,
  hotelJournalSummaryDateSuccess,
  finalTransaction_account_ReceivableList_success,
  finalTransaction_administrationList_success,
  finalTransaction_banquet_BeverageList_success,
  finalTransaction_cashList_success,
  finalTransaction_credit_CardsList_success,
  finalTransaction_miscellaneousList_success,
  finalTransaction_room_revenueList_success,
  finalTransaction_taxList_success,
  finalTransaction__finalTransactionCloseoutDate_success,
  hotelStatasticsDatesuccess,
  hotalStatisticsListsuccess,
  inHouseDatesuccess,
  inHouseListSuccess,
  inHouseListFailed,
  inhouseDatagridOptionsSucces,
  inhouseDatagridPrintOptionsSucces,

  checkinSearchFilterSucces,
checkinListSuccess,
checkinListFailed,
checkinDatagridOptionsSucces,
checkinDatagridPrintOptionsSucces,

checkOutListSuccess,
checkOutListFailed,
checkOutDatagridOptionsSuccess,
checkOutDatagridPrintOptionsSuccess,
checkOutSearchFilterSuccess,

ledgerSummaryDatagridOptionsSuccess,
ledgerSummarySearchFiltersSuccess,

activityLogDatagridOptionsSucces,
activityLogDatagridPrintOptionsSucces,
activityLogSearchFiltersSucces,

revenueByRoomTypeListSuccess,
revenueByRoomTypeListFailed,
revenueBreakdownListSuccess,
revenueBreakdownListFailed,
revenueAdrListSuccess,
revenueAdrListFailed,
flashDatagridOptionsSuccess,
revenueDatagridOptionsSuccess,
adrDatagridOptionsSuccess,
flashSearchFilterSuccess,
flashTabSuccess,
flashSummuryDataSuccess,
flashRoomSoldArrSuccess,
flashRevenueSummuryDataSuccess,
flashAdrSummuryDataSuccess,
flashDataGridColumnsSuccess,           
flashRevenueDataGridColumnsSuccess,  
} = nightReportSlice.actions;
export default nightReportSlice.reducer;
